import { createSlice } from '@reduxjs/toolkit'
import { gameConfigurations } from '@configurations/gameConfigurations'
import { applyFeatureOverrides } from '@configurations/featureOverrides'

const initialState = {
  stakeConfigurations: {
    minimumStakeAmount: gameConfigurations.defaultStakeConfigurations.minimumStakeAmount,
    maximumStakeAmount: gameConfigurations.defaultStakeConfigurations.maximumStakeAmount,
    defaultStakeAmount: gameConfigurations.defaultStakeConfigurations.defaultStakeAmount,
    step: gameConfigurations.defaultStakeConfigurations.step,
    presetStakes: gameConfigurations.defaultStakeConfigurations.presetStakes,
  },
  featureToggles: applyFeatureOverrides({
    jackpot: false,
    tournaments: false,
    buyBonus: false,
    freebets: false,
    missions: false,
    chat: false,
  }),
}

const configurationsSlice = createSlice({
  name: 'configurations',
  initialState,
  reducers: {
    setStakeConfigurations: (state, action) => {
      const { minimumStakeAmount, maximumStakeAmount, defaultStakeAmount, step, presetStakes } =
        action.payload
      state.stakeConfigurations = {
        minimumStakeAmount,
        maximumStakeAmount,
        defaultStakeAmount,
        step,
        presetStakes,
      }
    },
    setFeatureToggles: (state, action) => {
      const { jackpot, tournaments, buyBonus, freebets, missions, chat, gameCode } = action.payload
      state.featureToggles = applyFeatureOverrides(
        {
          jackpot,
          tournaments,
          buyBonus,
          freebets,
          missions,
          chat,
        },
        gameCode
      )
    },
  },
})

export const { setStakeConfigurations, setFeatureToggles } = configurationsSlice.actions
export default configurationsSlice.reducer
